import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-new-app-properties',
  templateUrl: './new-app-properties.component.html',
  styleUrls: ['./new-app-properties.component.css']
})
export class NewAppPropertiesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
